var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11908_6451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 10.6665C8.95232 11.0492 9.31759 11.3659 9.73705 11.5951C10.1565 11.8243 10.6204 11.9606 11.0971 11.9947C11.5739 12.0288 12.0524 11.9601 12.5002 11.793C12.9481 11.6259 13.3548 11.3645 13.6927 11.0265L15.6927 9.02648C16.2999 8.39781 16.6359 7.5558 16.6283 6.68181C16.6207 5.80782 16.2701 4.97178 15.6521 4.35375C15.0341 3.73573 14.198 3.38516 13.324 3.37757C12.45 3.36997 11.608 3.70595 10.9793 4.31315L9.83268 5.45315",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.333 9.33332C11.0467 8.95057 10.6814 8.63387 10.2619 8.40469C9.84248 8.17552 9.37864 8.03924 8.90188 8.0051C8.42512 7.97095 7.94659 8.03974 7.49875 8.2068C7.05091 8.37386 6.64424 8.63527 6.30631 8.97332L4.30631 10.9733C3.69912 11.602 3.36314 12.444 3.37073 13.318C3.37833 14.192 3.72889 15.028 4.34692 15.646C4.96494 16.2641 5.80098 16.6146 6.67497 16.6222C7.54896 16.6298 8.39097 16.2938 9.01964 15.6867L10.1596 14.5467",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11908_6451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(1.99951 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.4a82a6167f1e7d51f6f6e61cbec16531.svg";
export { ForwardRef as ReactComponent };